const LEGACY_HTML_TAG_REGEXP = /<\/?(?:strong|b|em|i|br|div|p|li|h[1-6])\b[^>]*>/i;
const LINE_BREAK_TAG_REGEXP = /<br\s*\/?>/gi;
const BLOCK_END_TAG_REGEXP = /<\/(?:div|p|li|h[1-6])>/gi;
const HTML_TAGS_REGEXP = /<[^>]*>/g;

const FALLBACK_HTML_ENTITIES: Record<string, string> = {
  '&nbsp;': ' ',
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
};

const decodeHtmlEntities = (value: string) => {
  if (!value || typeof document === 'undefined') {
    return Object.entries(FALLBACK_HTML_ENTITIES).reduce(
      (decodedValue, [entity, replacement]) => decodedValue.replaceAll(entity, replacement),
      value
    );
  }

  const textArea = document.createElement('textarea');
  textArea.innerHTML = value;

  return textArea.value;
};

const legacyHtmlToPlainText = (value: string) =>
  decodeHtmlEntities(
    value
      .replace(LINE_BREAK_TAG_REGEXP, '\n')
      .replace(BLOCK_END_TAG_REGEXP, '\n')
      .replace(HTML_TAGS_REGEXP, '')
  );

export const getCommentPlainText = (value?: string) => {
  const rawValue = value ?? '';

  return LEGACY_HTML_TAG_REGEXP.test(rawValue)
    ? legacyHtmlToPlainText(rawValue)
    : decodeHtmlEntities(rawValue);
};

export const formatCommentValue = (text: string) => text.trim();
